<template>
    <div class="mobile-menu d-block d-md-none">
        <nav class="nav mobile-menu__nav">
            <a
                class="nav-link mobile-menu__nav-link"
                :class="{'mobile-menu__nav-link--active': activeTab === 'home' && !categoriesOpen}"
                href="/"
                @pointerdown="prefetch('/')"
                @click="navigate($event, '/')"
            >
                <span class="icon-Home mobile-menu__nav-icon"></span>
                <span class="mobile-menu__nav-text">خانه</span>
            </a>
            <button
                type="button"
                class="nav-link mobile-menu__nav-link mobile-menu__nav-link--button"
                :class="{'mobile-menu__nav-link--active': categoriesOpen}"
                @click.stop="toggleCategories"
            >
                <span class="icon-Folder_open mobile-menu__nav-icon"></span>
                <span class="mobile-menu__nav-text">دسته بندی</span>
            </button>
            <a
                class="nav-link mobile-menu__nav-link"
                :class="{'mobile-menu__nav-link--active': activeTab === 'cart' && !categoriesOpen}"
                :href="route('shopping-cart')"
                @pointerdown="prefetch(route('shopping-cart'))"
                @click="navigate($event, route('shopping-cart'))"
            >
                <span class="icon-Bag mobile-menu__nav-icon">
                    <span class="mobile-menu__cart-badge" v-if="totals.quantity > 0">{{ totals.quantity }}</span>
                </span>
                <span class="mobile-menu__nav-text">سبد خرید</span>
            </a>
            <a
                class="nav-link mobile-menu__nav-link"
                :class="{'mobile-menu__nav-link--active': activeTab === 'profile' && !categoriesOpen}"
                :href="profileUrl"
                @pointerdown="prefetch(profileUrl)"
                @click="navigate($event, profileUrl)"
            >
                <span class="icon-Profile mobile-menu__nav-icon"></span>
                <span class="mobile-menu__nav-text">پروفایل</span>
            </a>
        </nav>
    </div>
</template>

<script>
import {CartMixin} from "../cart/CartMixin";

export default {
    name: "MobileMenu",
    mixins: [CartMixin],
    data() {
        return {
            currentPath: window.location.pathname,
        };
    },
    computed: {
        categoriesOpen() {
            return this.$store.state.general.categoriesPanelOpen;
        },
        activeTab() {
            const path = this.currentPath;

            if (path === '/' || path === '') {
                return 'home';
            }

            if (path.startsWith('/shopping-cart') || path.startsWith('/checkout')) {
                return 'cart';
            }

            if (path.startsWith('/profile') || path.startsWith('/login')) {
                return 'profile';
            }

            return null;
        },
        profileUrl() {
            return this.isLoggedIn() ? this.route('site.profile') : this.route('site.login');
        },
    },
    mounted() {
        this.onPageLoad = () => {
            this.currentPath = window.location.pathname;
        };
        document.addEventListener('page:load', this.onPageLoad);
    },
    beforeUnmount() {
        document.removeEventListener('page:load', this.onPageLoad);
    },
    methods: {
        toggleCategories() {
            this.$store.commit(
                'general/setCategoriesPanelOpen',
                !this.$store.state.general.categoriesPanelOpen
            );
        },
        prefetch(url) {
            if (typeof window.prefetchPage === 'function') {
                window.prefetchPage(url);
            }
        },
        navigate(event, url) {
            this.$store.commit('general/setCategoriesPanelOpen', false);
            event.preventDefault();
            this.currentPath = new URL(url, window.location.origin).pathname;

            if (typeof window.navigateToPage === 'function') {
                window.navigateToPage(url);
                return;
            }

            window.location.href = url;
        },
    },
};
</script>
